import React from 'react';

export default function Transform(object) {
  return object.props.children;
}
